import axios from 'axios'

const isLocalDevHost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')

const defaultBaseURL = isLocalDevHost
  ? 'http://localhost:4000'
  : window.location.origin

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || defaultBaseURL,
})

axiosInstance.interceptors.request.use(function (config) {
  let token = ''
  try {
    const raw = localStorage.getItem('token')
    token = raw ? JSON.parse(raw) : ''
  } catch {
    token = ''
  }

  if (token) {
    config.headers.Authorization = `${token}`
  } else {
    delete config.headers.Authorization
  }

  if (!(config.data instanceof FormData)) {
    config.headers['Content-Type'] = 'application/json'
  }

  return config
})

export default axiosInstance
